import { useState } from "react";
import { LockKeyhole, Mail, User } from "lucide-react";
import "bootstrap/dist/css/bootstrap.min.css";
import Cookies from "js-cookie";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import API_BASE_URL from "./Config";

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);


    const navigate = useNavigate();
  const handleSubmit = (e) => {
    e.preventDefault();
     fetch(`${API_BASE_URL}login`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify({ email, password }),
        })
        .then((response) => response.json())
        .then((data) => {
            if(data.success){
                toast.success('Login successful');
                Cookies.set("token", data.token, { 
                  expires: 55 / (60 * 24), 
                    secure: true,
                    sameSite: "Strict"
                  });
                  Cookies.set("userId", data.userId, { 
                    expires: 55 / (60 * 24),
                    secure: true,
                    sameSite: "Strict"
                  });
                  Cookies.set("username", data.username, { 
                    expires: 55 / (60 * 24), 
                      secure: true,
                      sameSite: "Strict"
                    });
                  navigate("/home")
            }else{
                toast.error('Invalid Credentials');
            }
        })
        .catch((error) => {
            toast.error('Login failed');
        }
    )
  };

  return (
    <div className="container-fluid vh-100">
      <div className="row h-100">
        <div className="col-lg-6 d-flex flex-column justify-content-center align-items-center min-vh-100">
          <div className="p-4 w-100" style={{ maxWidth: "400px" }}>
            <div className="text-center mb-4">
              <div
                className="d-inline-flex align-items-center justify-content-center bg-light rounded-circle mb-3"
                style={{ width: "70px", height: "70px" }}
              >
                <User className="text-primary" size={32}style={{color:'linear-gradient(135deg, #0d47a1, #1976d2)'}}/>
              </div>
              <h2 className="fw-bold">Admin Portal</h2>
              <p className="text-muted">Enter your credentials to access your account</p>
            </div>


            <form onSubmit={handleSubmit}>
              <div className="mb-3">
                <label htmlFor="email" className="form-label fw-semibold">Email</label>
                <div className="input-group">
                  <span className="input-group-text"><Mail size={18} /></span>
                  <input
                    type="email"
                    id="email"
                    className="form-control"
                    placeholder="admin@prowesserp.com"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                  />
                </div>
              </div>

              <div className="mb-3">
                <label htmlFor="password" className="form-label fw-semibold">Password</label>
                <div className="input-group">
                  <span className="input-group-text"><LockKeyhole size={18} /></span>
                  <input
                    type={showPassword ? 'text' : 'password'}
                    id="password"
                    className="form-control"
                    placeholder="Enter your password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    required
                  />
                  <button 
                  type="button" 
                  className="password-toggle input-group-text"
                  onClick={() => setShowPassword(!showPassword)}
                >
                  {showPassword ? (
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <path d="M9.88 9.88a3 3 0 1 0 4.24 4.24"></path>
                      <path d="M10.73 5.08A10.43 10.43 0 0 1 12 5c7 0 10 7 10 7a13.16 13.16 0 0 1-1.67 2.68"></path>
                      <path d="M6.61 6.61A13.526 13.526 0 0 0 2 12s3 7 10 7a9.74 9.74 0 0 0 5.39-1.61"></path>
                      <line x1="2" x2="22" y1="2" y2="22"></line>
                    </svg>
                  ) : (
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <path d="M2 12s3-7 10-7 10 7 10 7-3 7-10 7-10-7-10-7Z"></path>
                      <circle cx="12" cy="12" r="3"></circle>
                    </svg>
                  )}
                </button>
                </div>
              </div>


              <button type="submit" className="btn btn-primary w-100 fw-semibold" style={{background:'linear-gradient(135deg, #0d47a1, #1976d2)'}}>
                Sign in
              </button>

              <div className="text-center mt-3">
                <small className="text-muted">Don't have an account? </small>
                <a href="#" className="text-decoration-none text-primary fw-semibold">Contact administrator</a>
              </div>
            </form>
          </div>
        </div>

        <div className="col-lg-6 d-none d-lg-flex align-items-center justify-content-center position-relative text-white"
     style={{ 
       background: "linear-gradient(135deg, #0d47a1, #1976d2)", 
       color: "white"
     }}>
  

  <div className="position-absolute top-0 start-0 w-100 h-100"
       style={{ 
         backgroundImage: "url('/abstract-pattern.png')",
         backgroundSize: "cover",
         backgroundPosition: "center",
         opacity: 0.08 
       }}>
  </div>

  <div className="text-center p-5 position-relative w-100">

    <h3 className="fw-bold text-uppercase"><img src="./prowess-logo-white.png" alt="ProwessErp Logo" /></h3>
    <hr className="mx-auto" style={{ width: "80px", border: "2px solid white", opacity: 0.7 }} />


    <h2 className="fw-bold display-7 mt-4">Executive Control Center</h2>
    <p className="fs-6 opacity-75">Enterprise Control at Your Fingertips</p>

    <div className="d-flex justify-content-center gap-4 mt-5" style={{ maxWidth: "500px", margin: "0 auto" }}>
      <div className="p-4 bg-white bg-opacity-10 rounded shadow-sm w-100 d-flex flex-column align-items-center">
        <i className="bi bi-cloud-upload text-white" style={{ fontSize: "2.5rem" }}></i>
        <p className="mt-2 opacity-90 fw-semibold">Upload New Videos</p>
      </div>

      <div className="p-4 bg-white bg-opacity-10 rounded shadow-sm w-100 d-flex flex-column align-items-center">
        <i className="bi bi-pencil-square text-white" style={{ fontSize: "2.5rem" }}></i>
        <p className="mt-2 opacity-90 fw-semibold">Manage Videos</p>
      </div>

      <div className="p-4 bg-white bg-opacity-10 rounded shadow-sm w-100 d-flex flex-column align-items-center">
        <i className="bi bi-bar-chart-line text-white" style={{ fontSize: "2.5rem" }}></i>
        <p className="mt-2 opacity-90 fw-semibold">Video Analytics</p>
      </div>
    </div>

    <div className="mt-5 opacity-50">
      <p className="mb-0 small">© 2025 ProwessERP | Admin Dashboard</p>
    </div>
  </div>
</div>

      </div>
    </div>
  );
}
